import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

import { baseColumns } from './baseColumns';

export const factiiiEngagements = sqliteTable(
  'factiii_engagements',
  {
    ...baseColumns,
    factiiiId: integer('factiii_id').notNull(),
    factiiiName: text('factiii_name').notNull(),
    viewedAt: integer('viewed_at').notNull(), // Unix timestamp (ms)
    duration: integer('duration').notNull()
  },
  (t) => [
    index('idx_factiii_engagements_viewed_at').on(t.viewedAt),
    index('idx_factiii_engagements_created_at').on(t.createdAt),
    index('factiii_engagements_factiii_viewed').on(t.factiiiId, t.viewedAt)
  ]
);
